import {Tooltip, IconButton} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutlined';

export interface HelpTooltipProps {
    text: string;
    size?: 'small' | 'medium';
    placement?: 'top' | 'bottom' | 'left' | 'right';
}

export function HelpTooltip({text, size = 'small', placement = 'top'}: HelpTooltipProps) {
    return (
        <Tooltip title={text} arrow placement={placement}>
            <IconButton
                size={size}
                sx={{
                    p: 0.25,
                    ml: 0.5,
                    color: 'text.secondary',
                    opacity: 0.6,
                    '&:hover': {opacity: 1},
                    '&:focus-visible': {
                        opacity: 1,
                        outline: '2px solid',
                        outlineColor: 'primary.main',
                        outlineOffset: 2,
                        borderRadius: '50%',
                    },
                }}
            >
                <HelpOutlineIcon fontSize={size === 'small' ? 'small' : 'medium'} />
            </IconButton>
        </Tooltip>
    );
}
